<template>
  <a-drawer width="50%" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="保证金主表ID" prop="bondId">
            <a-input-number v-model="form.bondId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="师傅订单ID" prop="masterOrderId">
            <a-input-number v-model="form.masterOrderId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="雇主订单ID" prop="customerOrderId">
            <a-input-number v-model="form.customerOrderId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="师傅用户ID" prop="masterUserId">
            <a-input-number v-model="form.masterUserId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="支付项类型" prop="itemType">
            <a-select v-model="form.itemType" placeholder="请选择">
              <a-select-option :value="1">抢单保证金</a-select-option>
              <a-select-option :value="2">保险保证金</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="支付项名称" prop="itemName">
            <a-input v-model="form.itemName" allow-clear />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="业务关联ID" prop="bizRefId">
            <a-input-number v-model="form.bizRefId" style="width: 100%" :min="0" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="展示排序" prop="sort">
            <a-input-number v-model="form.sort" style="width: 100%" :min="0" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="原始金额" prop="originalAmount">
            <a-input-number v-model="form.originalAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="应付金额" prop="payableAmount">
            <a-input-number v-model="form.payableAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="已付金额" prop="paidAmount">
            <a-input-number v-model="form.paidAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="已退金额" prop="refundAmount">
            <a-input-number v-model="form.refundAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="已扣金额" prop="deductAmount">
            <a-input-number v-model="form.deductAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="剩余金额" prop="remainingAmount">
            <a-input-number v-model="form.remainingAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="支付项状态" prop="itemStatus">
            <a-input-number v-model="form.itemStatus" style="width: 100%" :min="0" :max="7" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="是否可退" prop="isRefundable">
            <a-select v-model="form.isRefundable" placeholder="请选择" allow-clear>
              <a-select-option :value="false">否</a-select-option>
              <a-select-option :value="true">是</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="备注" prop="remark">
            <a-input v-model="form.remark" type="textarea" allow-clear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addOrderMasterBondItem, getOrderMasterBondItem, updateOrderMasterBondItem } from '@/api/order/masterBondItem'

function emptyForm() {
  return {
    id: null,
    bondId: null,
    masterOrderId: null,
    customerOrderId: null,
    masterUserId: null,
    itemType: 1,
    itemName: null,
    bizRefId: null,
    originalAmount: null,
    payableAmount: null,
    paidAmount: null,
    refundAmount: null,
    deductAmount: null,
    remainingAmount: null,
    itemStatus: 0,
    isRefundable: true,
    sort: 0,
    remark: null
  }
}

export default {
  name: 'OrderMasterBondItemCreateForm',
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      form: emptyForm(),
      formType: 1,
      open: false,
      rules: {
        bondId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        masterOrderId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        customerOrderId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        masterUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        itemType: [{ required: true, message: '不能为空', trigger: 'change' }],
        itemName: [{ required: true, message: '不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onClose() {
      this.open = false
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = emptyForm()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增保证金支付项'
    },
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      getOrderMasterBondItem({ id: row.id }).then(response => {
        const d = response.data
        this.form = {
          ...emptyForm(),
          ...d,
          isRefundable: d.isRefundable === true || d.isRefundable === 1
        }
        this.open = true
        this.formTitle = '编辑保证金支付项'
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = { ...this.form }
        if (this.formType === 1) {
          delete payload.id
        }
        const submit = payload.id != null ? updateOrderMasterBondItem(payload) : addOrderMasterBondItem(payload)
        submit
          .then(() => {
            this.$message.success(payload.id != null ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>
